import React from 'react'
import '../3-companies/Cstyle.css'


const Companies = () => {
  return (
    <>
        <div class="second-page" id='second-page'>
        <div class="second-top">
            
            <div class="second-top-2"></div>
            <div class="second-top-3"></div>
            <div class="second-top-4"></div>
            <div class="second-top-5"></div>
            <div class="second-top-6"></div>
            
        </div>  
        </div>
    </>
  )
}

export default Companies
